import { render, staticRenderFns } from "./Legacy.vue?vue&type=template&id=050b3d25&scoped=true&"
import script from "./Legacy.vue?vue&type=script&lang=js&"
export * from "./Legacy.vue?vue&type=script&lang=js&"
import style0 from "./Legacy.vue?vue&type=style&index=0&id=050b3d25&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b3d25",
  null
  
)

export default component.exports